/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';

import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import { defineMessages, injectIntl } from 'react-intl';
import { FormControl } from '@material-ui/core';
import clsx from 'clsx';
import uiActions from '../../../redux/actions/uiActions';
import groupActions from '../../../redux/actions/groupActions';

const styles = {
  root: {
    background: '#F9F9F9',
  },
  selected: {},
};

const drawerWidth = 350;

const messages = defineMessages({
  comment: {
    id: 'Group.comment',
    defaultMessage: 'Comment',
  },
});

const renderTextField = ({
  input,
  label,
  ...custom
}) => (
  <div>
    <TextField
      label={label}
        // value={writerComment}
        // onChange={(e) => setWriterComment(e.target.value)}
      {...input}
      {...custom}
      style={{ width: '100%', backgroundColor: 'white', marginTop: 20 }}
      id="outlined-uncontrolled"
      variant="outlined"
      color="primary"
    />
  </div>
);
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: '#f6f6f6',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginRight: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  contentSidebar: {
    margin: 30,
  },
}));

const Sidebar = (props) => {
  const {
    setSidebarState, panelState, children, intl,
  } = props;

  const classes = useStyles();
  const theme = useTheme();

  const handleDrawerClose = () => {
    setSidebarState();
  };

  return (
    <div className={classes.root}>
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: panelState,
        })}
      >
        {children}
      </main>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="right"
        open={panelState}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </div>
        <div className={classes.contentSidebar}>
          <Divider />
          <h4 style={{ marginTop: 20 }}>
            {intl.formatMessage(messages.comment)}
          </h4>
          <FormControl style={{ width: '100%' }} variant="outlined">
            <Field
              name="writerComment"
              label={intl.formatMessage(messages.comment)}
              multiline
              rows={10}
              component={renderTextField}
            />
          </FormControl>
        </div>
      </Drawer>
    </div>
  );
};

Sidebar.propTypes = {
  intl: PropTypes.object.isRequired,
  setSidebarState: PropTypes.func.isRequired,
  panelState: PropTypes.any.isRequired,
  children: PropTypes.any.isRequired,
};

function mapStateToProps(state) {
  const name = `group_${state.group.selectedGroup._id}`;
  const dataform = state.form[`group_${state.group.selectedGroup._id}`];
  const panelState = state.ui.commentPanel;
  return {
    initialValues: state.group.selectedGroup,
    form: name,
    dataform,
    panelState,
  };
}

const connectedGroupForm = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
})(withRouter(injectIntl(Sidebar)));

const actionCreators = {
  setSidebarState: uiActions.sidebarState,
  setSelectedGroup: groupActions.setSelectedGroup,
};

const SidebarComment = connect(
  mapStateToProps,
  actionCreators,
)(withStyles(styles)(connectedGroupForm));

export default SidebarComment;
